import * as React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import Divider from '@mui/joy/Divider';
import Typography from '@mui/joy/Typography';
import FundiBidCard from '../../card/fundi/FundiBidCard';
import { Stack } from '@mui/joy';



export default function PastJobsCard({ book = {} }) {

  const { author, title } = book;
  console.log("jobPastJobsCard", author, title);

    return (
        <>

            <Card variant="outlined" sx={{ width: '550px', margin: '0 auto', backgroundColor: 'transparent' }}>
                {/* <div>{book._id}</div> */}
                <Button
                    sx={{
                        padding: "5px 30px 5px", maxWidth: "40%", textAlign: "center",
                        backgroundColor: "#b3b15f",
                        "&:hover": {
                            backgroundColor: "#b3b15f",
                            color: "#ffffff", boxShadow: 3,
                        },

                    }}>Post a Bid</Button>
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'left' }}
                >
                    <Box>
                        <Typography gutterBottom variant="h5" component="div">
                            Job -
                        </Typography>
                        <Typography level='body-xs' sx={{ textAlign: 'center' }}>Plumbing (Leak Fixing) </Typography>

                    </Box>
                    <Box>
                        <Typography gutterBottom variant="h5" component="div">
                            Date & Time -
                        </Typography>
                        <Typography level='body-xs' sx={{ textAlign: 'left' }}>  12/01/2025 & Evening 2 to 7</Typography>

                    </Box>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4 }}

                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4 }}>
                        <FundiBidCard />
                        <Box>
                            <Typography gutterBottom variant="h5" component="div">
                                Kalvin {author}
                            </Typography>
                            <Typography level='body-xs' sx={{ textAlign: 'left' }}>  City Name, country Name</Typography>

                        </Box>
                    </Box>

                    <Button
                        sx={{
                            padding: "5px 30px 5px", maxWidth: "100%", textAlign: "center",
                            backgroundColor: "#28A745",
                            "&:hover": {
                                backgroundColor: "#28A745",
                                color: "#ffffff", boxShadow: 3,
                            },

                        }}>Update</Button>
                </Box>




            </Card>
          
        </>
    );
}

